import React from "react"
import { Pressable, Image, Text, View } from "react-native";

import { getImagePath, getStringWithItemCount } from "../../services/CommonUtils";

import AppTheme from "../../../AppTheme";
import AppStyles from "../../../AppStyles";
import TextStyle from "../../../TextStyle";

export const IconView = (props) => {
    var width = 24, height = 24
    var iconPath = props?.iconPath
    if (!iconPath) iconPath = '/images/icons/' + props?.icon
    let imageUrl = iconPath
    if (iconPath.indexOf('https://') == -1)
        imageUrl = getImagePath(iconPath)
    if (props.size) {
        height = props.size; width = props.size
    } else {
        if (props.height) height = props.height
        if (props.width) width = props.width
    }
    var action = props?.action
    var disabled = props?.disabled ?? false
    var iconStyle = props?.iconStyle ?? null
    var iconSize = { height: height, width: width }
    return <View>{!!action ? <Pressable onPress={() => action()}
        disabled={disabled} onLongPress={() => { console.log('### long press') }}>
        <Image source={{ uri: imageUrl }} style={[iconSize, iconStyle]} />
    </Pressable> : <Image source={{ uri: imageUrl }}
        style={[iconSize, iconStyle]} />}
    </View>
}

export const RightChevron = (props) => {
    const resize = props?.resize ?? 1
    const tintColor = props?.tintColor ?? 'white'
    const action = props?.action ?? null
    const disabled = action == null || (props?.disabled ?? false)
    return <Pressable onPress={action} disabled={action == null || disabled}
        onLongPress={() => { console.log('### long press') }}>
        <Image style={{ height: 11 * resize, width: 7 * resize, tintColor: tintColor }}
            source={{ uri: getImagePath('/images/icons/right_chevron_white.svg') }} />
    </Pressable>
}

export const RightArrowIcon = (props) => {
    let resize = props.resize ?? 1
    let tintColor = props.tintColor ?? 'white'
    return <Image style={{ tintColor: tintColor, height: 13 * resize, width: 18 * resize }}
        source={{ uri: getImagePath('/images/icons/right_arrow_white.svg') }} />
}

export const LeftChevron = (props) => {
    const resize = props?.resize ?? 1
    const tintColor = props?.tintColor ?? 'white'
    const action = props?.action ?? null
    const disabled = action == null || (props?.disabled ?? false)
    return <Pressable onPress={() => action()} disabled={disabled}
        onLongPress={() => { console.log('### long press') }}>
        <Image style={{ height: 11 * resize, width: 7 * resize, tintColor: tintColor }}
            source={{ uri: getImagePath('/images/icons/left_chevron_white.svg') }} />
    </Pressable>
}

export const DownChevron = (props) => {
    const resize = props?.resize ?? 1
    const tintColor = props?.tintColor ?? AppTheme.color.white
    const action = props?.action ?? null
    const disabled = action == null || (props?.disabled ?? false)
    var iconStyle = null
    if (props?.paddingLeft)
        iconStyle = { paddingLeft: props.paddingLeft, tintColor: tintColor }
    else iconStyle = { tintColor: tintColor }
    return <IconView height={7 * resize} width={11 * resize} icon={'chevron/down.svg'}
        iconStyle={iconStyle} action={action} disabled={disabled} />
}

export const CloseIcon = (props) => {
    let resize = props.resize ?? 1
    let tintColor = props.tintColor ?? 'black'
    return <Pressable onPress={props?.action ?? props.onPress}
        onLongPress={() => { console.log('### long press') }}>
        <Image source={{ uri: getImagePath('/images/icons/close.svg') }}
            style={{ tintColor: tintColor, height: 18 * resize, width: 18 * resize }} />
    </Pressable>
}

export const LocationIcon = (props) => {
    let resize = props.resize ?? 1
    let tintColor = props.tintColor ?? 'black'
    return <Image source={{ uri: getImagePath('/images/icons/location/black.svg') }}
        style={{ tintColor: tintColor, height: 18 * resize, width: 14 * resize }} />
}

export const SeeAllIcon = (props) => {
    const resize = 1
    const tintColor = AppTheme.color.primary
    const action = props?.action ?? null
    const disabled = action == null || (props?.disabled ?? false)
    let title = 'See All '
    if (props?.itemCount)
        title = getStringWithItemCount(props.itemCount, title, title)
    return <Pressable onPress={() => action()}
        style={AppStyles.flexRowEnd}>
        <Text style={[TextStyle.text14b, TextStyle.colorPrimary,
        { marginRight: 6 }]}>{title}</Text>
        <RightChevron resize={resize} tintColor={tintColor}
            action={action} disabled={disabled} />

    </Pressable>
}